<template>
    <div>
        <el-button :loading="loading"
                   @click="refresh"
                   icon="el-icon-refresh-right"
                   size="mini">
            重新載入
        </el-button>
        <el-button
                @click="showFilter = !showFilter"
                :icon="showFilter ? 'el-icon-remove-outline': 'el-icon-circle-plus-outline'"
                size="mini"
                type="success"
        >
            過濾器
        </el-button>
        <el-collapse-transition>
            <el-card
                    shadow="never"
                    style="margin: 2px 0;"
                    v-if="showFilter"
            >
                <el-form :model="filter" label-width="120px">
                    <el-row>
                        <el-col :xl="6">
                            <el-form-item label="教室">
                                <el-select
                                        clearable
                                        multiple
                                        placeholder="請選擇教室(多選)"
                                        v-model="filter.roomIds"
                                        filterable
                                >
                                    <el-option
                                            :key="r.ncutRoomId"
                                            :label="r.name + (r.isHidden ? '（已隱藏）' : '')"
                                            :value="r.ncutRoomId"
                                            v-for="r in rooms"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xl="8">
                            <el-form-item label="日期起訖">
                                <el-date-picker
                                        end-placeholder="請選擇結束日期"
                                        range-separator="到"
                                        start-placeholder="請選擇開始日期"
                                        type="daterange"
                                        v-model="filter.range"
                                        value-format="yyyy-MM-dd"
                                        :picker-options="{firstDayOfWeek:1}"
                                ></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :xl="6">
                            <el-form-item label="借用星期">
                                <el-select
                                        clearable
                                        multiple
                                        placeholder="請選擇借用星期(多選)"
                                        v-model="filter.weekdays"
                                >
                                    <el-option
                                            :key="w.key"
                                            :label="w.label"
                                            :value="w.key"
                                            v-for="w in weekdays"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>

                    </el-row>
                    <el-row>
                        <el-col :xl="12">
                            <el-form-item label="借用節次(起訖)">
                                <period-picker
                                        :comparer="(b, e) => e >= b"
                                        :options="periodOpts"
                                        @beginChange="filter.periods[1] = ''"
                                        clearable
                                        v-model="filter.periods"
                                ></period-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-card>
        </el-collapse-transition>
        <el-divider v-if="showFilter">分隔線</el-divider>
        <el-table
                :data="pagedForms"
                :stripe="true"
                empty-text="本學期無表單"
                height="620px"
                size="small"
                row-key="id"
        >
            <el-table-column
                    label="表單編號"
                    prop="formNo">
            </el-table-column>
            <el-table-column
                    label="教室"
            >
                <template #default="{row}">
                    {{roomName(row)}}
                </template>
            </el-table-column>
            <el-table-column
                    label="申請日期"
            >
                <template #default="{row}">
                    {{`${row.date} (${toWeekdayFmt(row.weekday)}) [${row.begin}-${row.end}]`}}
                </template>
            </el-table-column>
            <el-table-column
                    label="申請人"
            >
                <template #default="{row}">
                    {{ row.applicant | prettyUsernameFull}}
                </template>
            </el-table-column>
            <el-table-column
                    label="申請事由"
            >
                <template #default="{row}">
                    {{row.notForCourseOrExam ? `(其它)${row.reason}` : `${row.form.byAdmin ? '' : '(上課/考試)'}${row.reason}`}}
                </template>
            </el-table-column>
            <el-table-column
                    label="操作"
            >
                <template #default="{row}">
                    <el-button
                            @click="selectAndShow(row.form)"
                            size="small"
                            type="primary"
                    >
                        詳細
                    </el-button>
                    <el-button
                            :disabled="!row.cancelable"
                            @click="cancel(row)"
                            size="small"
                            type="danger"

                    >
                        {{row.cancelable ? '註銷' : '已註銷'}}
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                :current-page.sync="currentPage"
                :page-size="pageSize"
                :total="filteredEvents.length"
                @current-change="page => pageChange(page, filteredEvents)"
                background
                layout="total, prev, pager, next"
                style="margin-top: 10px;"
        ></el-pagination>
        <el-dialog
                :title="title"
                :visible.sync="show"
                top="5vh"
                v-if="show"
        >
            <form-detail :form="selectedForm"></form-detail>
            <div v-if="isDenied">
                <el-divider>退件原因</el-divider>
                <div style="margin-bottom: 10px;">
                    <el-input
                            :value="denyReason"
                            disabled
                            type="textarea"
                    ></el-input>
                </div>
            </div>
            <template #footer>
                <el-button @click="show = false">關閉</el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import formTableMixin from '../../formTableMixin';
import PeriodPicker from '../PeriodPicker';
import {TotalPeriods, Weekdays} from '../../constants';
import moment from 'moment';
import ElCollapseTransition from 'elementui-lts/lib/transitions/collapse-transition';

const defaultFilter = {
        roomIds: [],
        range: undefined,
        weekdays: [],
        periods: []
    };
    export default {
        name: 'RoomBookingManage',
        data: () => ({
            pageSize: 12,
            mode: 'form',
            showFilter: false,
            filter: {...defaultFilter},

        }),
        components: {
            ElCollapseTransition,
            PeriodPicker
        },
        computed: {
            ...mapState('manage', ['forms']),
            ...mapState('setting', ['rooms']),

            filteredEvents() {
                const {roomIds, range, weekdays, periods} = this.filter;
                return this
                    .events
                    .filter(e =>
                        roomIds.length === 0 || roomIds.some(r => r === e.roomId))
                    .filter(e =>
                        (!range || moment(e.date)
                                .isBetween(range[0], range[1], 'd', '[]')
                        )
                    )
                    .filter(e => weekdays.length === 0 || weekdays.some(w => w === e.weekday))
                    .filter(e => (!periods[0] || !periods[1]) || e.begin >= periods[0] && e.end <= periods[1])
                    ;
            },

            events() {
                return this.forms.reduce((ary, f) => {
                    const {
                        roomName,
                        reason,
                        applicant,
                        formNo,
                        createdAt,
                        notForCourseOrExam,
                        roomId,
                    } = f;
                    return [...ary, ...f.periods.map(p => ({
                        ...p,
                        roomName,
                        reason,
                        applicant,
                        formNo,
                        createdAt,
                        roomId,
                        notForCourseOrExam,
                        form: f,
                    }))]
                }, []);
            },
            weekdays() {
                return [...Array(7).keys()].map(w => ({
                    key: w + 1,
                    label: Weekdays[w + 1]
                }));
            },
            periodOpts() {
                return [...Array(TotalPeriods).keys()].map(p => ({
                    key: p + 1,
                    label: `第${p + 1}節`,
                    value: p + 1
                }))
            }
        },
        mixins: [formTableMixin],
        props: {
            loading: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            ...mapActions('manage', {
                getForms: 'getFormsAction',
                deleteFormOf: 'deleteFormAction',
                cancelEvent: 'cancelEventAction',
            }),

            async cancel({id}) {
                try {
                    await this.$confirm('確定要註銷嗎?(註銷後將不能回復)', {
                        type: 'danger',
                    });
                    const {success} = await this.cancelEvent(id);

                    if (success) {
                        this.$message.success('註銷成功');
                    } else {
                        this.$message.warning('註銷失敗，請重試一次');
                    }
                } catch (e) {
                    if (e !== 'cancel') {
                        this.$message({
                            type: 'error',
                            message: '發生錯誤，請重試一次!'
                        });
                    }
                }
            },

            async refresh() {
                await this.getForms();
                this.clearFilter();
            },

            toWeekdayFmt(weekday) {
                return Weekdays[weekday];
            },

            roomName({roomName, roomId}) {
                const room = this.rooms.find(r => r.ncutRoomId === roomId);
                return roomName + (room && room.isHidden ? '（已隱藏）' : '');
            },

            clearFilter() {
                this.filter = {...defaultFilter};
            }
        }
        ,
        watch: {
            filteredEvents(current) {
                this.pagedForms = this.pageData(current, 1);
                this.currentPage = 1;
            }
        }
        ,
        async created() {
            await this.getForms();
        }
    }
</script>

<style>

</style>
